export default function MatrixBackground() {
  return (
    <div className="absolute inset-0 pointer-events-none opacity-20">
      <div 
        className="absolute inset-0"
        style={{
          backgroundImage: `
            radial-gradient(circle at 25% 25%, rgba(0, 255, 255, 0.1) 0%, transparent 50%),
            radial-gradient(circle at 75% 75%, rgba(255, 215, 0, 0.1) 0%, transparent 50%),
            linear-gradient(45deg, transparent 30%, rgba(0, 255, 255, 0.02) 50%, transparent 70%)
          `,
          animation: 'matrix-flow 8s ease-in-out infinite alternate'
        }}
      />
      <style>{`
        @keyframes matrix-flow {
          0% { 
            background-position: 0% 0%, 100% 100%, 0% 0%;
            opacity: 0.15;
          }
          50% { 
            background-position: 100% 50%, 0% 50%, 50% 100%;
            opacity: 0.25;
          }
          100% { 
            background-position: 50% 100%, 50% 0%, 100% 50%;
            opacity: 0.15;
          }
        }
      `}</style>
    </div>
  );
}
